<script setup lang="ts">
import type { LineItem } from '~/types/shopware'
import { useCartLineItemUi } from '~/composables/useCartLineItemUi'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    cartItem: LineItem
    maxQty?: number
  }>(),
  {
    maxQty: 100,
  },
)

const { cartItem } = toRefs(props)
const { isLoading, quantity, itemTotalPrice, isPromotion, itemUrl, cover, getFormattedPrice, removeCartItem } =
  useCartLineItemUi(cartItem)
</script>

<template>
  <div class="wrapper">
    <img
      v-if="!isPromotion && cover"
      :src="cover?.url"
      :alt="cover?.alt || cartItem?.label || 'product image'"
      :title="cover?.title || cartItem?.label || 'product image'"
    />
    <div class="details">
      <h3 class="text-small">
        <NuxtLink v-if="itemUrl" :to="itemUrl">
          {{ cartItem.label }}
        </NuxtLink>
      </h3>
      <div class="quantity-price">
        <span class="text-small f-medium">{{ getFormattedPrice(itemTotalPrice) }}</span>
        <input
          v-if="!isPromotion"
          v-model="quantity"
          type="number"
          :disabled="isLoading"
          :min="cartItem.quantityInformation?.minPurchase || 1"
          :max="cartItem.quantityInformation?.maxPurchase || maxQty"
          :step="cartItem.quantityInformation?.purchaseSteps || 1"
          name="quantity"
        />
      </div>
      <button class="close" type="button" :disabled="isLoading" :aria-label="t('remove item')" @click="removeCartItem">
        <Icon name="large-close" />
      </button>
    </div>
  </div>
</template>
<style scoped lang="scss">
.wrapper {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 5fr;
  padding: 12px 0 24px 0;
  border-top: 1px solid var(--c-line-light);
  img {
    border-radius: 5px;
    box-shadow: var(--shadow);
  }
  .details {
    position: relative;
    h3 {
      padding-right: 20px;
    }
    .quantity-price {
      text-align: right;
      input {
        width: 90px;
        height: 54px;
        border: 1px solid var(--c-line-light);
        padding: 16px;
        text-align: center;
        margin-left: 16px;
      }
    }
    .close {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
</style>
